export default "__VITE_PUBLIC_ASSET__a52fb245__"